var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 409.8 409.8",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M228.9 205 404.6 29.3c6.8-6.5 7-17.4.4-24.1-6.5-6.8-17.4-7-24.1-.4l-.4.4-175.7 175.7L29.1 5.2C22.3-1.3 11.5-1.2 5 5.6c-6.4 6.6-6.4 17.1 0 23.7L180.7 205 5 380.7c-6.7 6.7-6.7 17.5 0 24.1 6.7 6.7 17.5 6.7 24.1 0l175.7-175.7 175.7 175.7c6.8 6.5 17.6 6.4 24.1-.4 6.4-6.6 6.4-17.1 0-23.7L228.9 205z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2a6500906e8c03ae4f274750871d0581.svg";
export { ForwardRef as ReactComponent };